<template>
  <ContentWrap>
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item v-show="false" label="hideId">
        <el-input v-model="formData.id" />
      </el-form-item>
      <el-tabs v-model="activeTab">
        <!-- 售后 -->
        <el-tab-pane label="售后">
          <el-form-item label="退款理由" prop="afterSaleRefundReasons">
            <el-select
              v-model="formData.afterSaleRefundReasons"
              allow-create
              filterable
              multiple
              placeholder="请直接输入退款理由"
            >
              <el-option
                v-for="reason in formData.afterSaleRefundReasons"
                :key="reason"
                :label="reason"
                :value="reason"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="退货理由" prop="afterSaleReturnReasons">
            <el-select
              v-model="formData.afterSaleReturnReasons"
              allow-create
              filterable
              multiple
              placeholder="请直接输入退货理由"
            >
              <el-option
                v-for="reason in formData.afterSaleReturnReasons"
                :key="reason"
                :label="reason"
                :value="reason"
              />
            </el-select>
          </el-form-item>
        </el-tab-pane>
        <!-- 配送 -->
        <el-tab-pane label="配送">
          <el-form-item label="启用包邮" prop="deliveryExpressFreeEnabled">
            <el-switch v-model="formData.deliveryExpressFreeEnabled" style="user-select: none" />
            <el-text class="w-full" size="small" type="info"> 商城是否启用全场包邮</el-text>
          </el-form-item>
          <el-form-item label="满额包邮" prop="deliveryExpressFreePrice">
            <el-input-number
              v-model="formData.deliveryExpressFreePrice"
              :min="0"
              :precision="2"
              class="!w-xs"
              placeholder="请输入满额包邮"
            />
            <el-text class="w-full" size="small" type="info">
              商城商品满多少金额即可包邮，单位：元
            </el-text>
          </el-form-item>
          <el-form-item label="排除地区" prop="deliveryExpressFreeExcludeAreaIds">
            <el-cascader
              v-model="formData.deliveryExpressFreeExcludeAreaIds"
              :options="areaTree"
              :props="areaCascaderProps"
              class="!w-md"
              clearable
              filterable
              collapse-tags
              collapse-tags-tooltip
              placeholder="选择不享受满额/活动包邮的地区"
            />
            <el-text class="w-full" size="small" type="info">
              以下地区不享受满额包邮与满减送活动包邮，仍按运费模板计费（请选与收货地址同级的区县）
            </el-text>
          </el-form-item>
          <el-form-item label="启用门店自提" prop="deliveryPickUpEnabled">
            <el-switch v-model="formData.deliveryPickUpEnabled" style="user-select: none" />
          </el-form-item>
          <el-form-item
            v-if="formData.deliveryPickUpEnabled"
            label="自提模式"
            prop="deliveryPickUpMode"
          >
            <el-radio-group v-model="formData.deliveryPickUpMode">
              <el-radio :value="0">平台门店池（旧）</el-radio>
              <el-radio :value="1">一店一点（新）</el-radio>
            </el-radio-group>
            <el-text class="w-full" size="small" type="info">
            平台门店池：C 端从平台维护的门店列表选自提点，多店可共选同一点。一店一点：每个店铺维护自己的自提点，多店合单自提时各店货提到各自自提点；需各店铺先配置自提信息。
            </el-text>
          </el-form-item>
          <el-form-item
            v-if="formData.deliveryPickUpEnabled"
            label="待核销超时关闭"
            prop="pickUpVerifyAutoCloseEnabled"
          >
            <el-switch v-model="formData.pickUpVerifyAutoCloseEnabled" style="user-select: none" />
            <el-text class="w-full" size="small" type="info">
              开启后：已支付的自提订单，超过下方天数仍未到店核销，系统将自动关闭订单并原路退款
            </el-text>
          </el-form-item>
          <el-form-item
            v-if="formData.deliveryPickUpEnabled && formData.pickUpVerifyAutoCloseEnabled"
            label="超时天数"
            prop="pickUpVerifyAutoCloseDays"
          >
            <el-input-number
              v-model="formData.pickUpVerifyAutoCloseDays"
              :min="1"
              :max="365"
              class="!w-xs"
              placeholder="请输入天数"
            />
            <el-text class="w-full" size="small" type="info">
              自支付成功起算，默认 7 天；小程序订单页会提示核销截止时间
            </el-text>
          </el-form-item>
        </el-tab-pane>
        <!-- 分销 -->
        <el-tab-pane label="分销">
          <el-form-item label="分佣启用" prop="brokerageEnabled">
            <el-switch v-model="formData.brokerageEnabled" style="user-select: none" />
            <el-text class="w-full" size="small" type="info"> 商城是否开启分销模式</el-text>
          </el-form-item>
          <el-form-item label="分佣模式" prop="brokerageEnabledCondition">
            <el-radio-group v-model="formData.brokerageEnabledCondition">
              <el-radio
                v-for="dict in getIntDictOptions(DICT_TYPE.BROKERAGE_ENABLED_CONDITION)"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </el-radio>
            </el-radio-group>
            <el-text class="w-full" size="small" type="info">
              人人分销：每个用户都可以成为推广员（绑定后自动具备资格）
            </el-text>
            <el-text class="w-full" size="small" type="info">
              指定分销：仅可在后台手动设置推广员
            </el-text>
            <el-text class="w-full" size="small" type="info">
              申请分销：用户在移动端填写灵工同步/提现必填信息提交申请，后台审核通过后开通
            </el-text>
          </el-form-item>
          <el-form-item label="分销关系绑定" prop="brokerageBindMode">
            <el-radio-group v-model="formData.brokerageBindMode">
              <el-radio
                v-for="dict in getIntDictOptions(DICT_TYPE.BROKERAGE_BIND_MODE)"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </el-radio>
            </el-radio-group>
            <el-text class="w-full" size="small" type="info">
              首次绑定：只要用户没有推广人，随时都可以绑定推广关系
            </el-text>
            <el-text class="w-full" size="small" type="info">
              注册绑定：只有新用户注册时或首次进入系统时才可以绑定推广关系
            </el-text>
          </el-form-item>
          <el-form-item label="分销海报图">
            <UploadImgs v-model="formData.brokeragePosterUrls" height="125px" width="75px" />
            <el-text class="w-full" size="small" type="info">
              此处仍可用于<strong>商品推广海报</strong>、<strong>拼团推广海报</strong>等静图底图。
              <strong>个人邀请海报</strong>请到「分销管理 → 分销海报」可视化配置（背景 + 头像/昵称/小程序码）。
            </el-text>
          </el-form-item>
          <el-form-item label="一级返佣比例" prop="brokerageFirstPercent">
            <el-input-number
              v-model="formData.brokerageFirstPercent"
              :max="100"
              :min="0"
              class="!w-xs"
              placeholder="请输入一级返佣比例"
            />
            <el-text class="w-full" size="small" type="info">
              订单交易成功后给推广人返佣的百分比
            </el-text>
          </el-form-item>
          <el-form-item label="二级返佣比例" prop="brokerageSecondPercent">
            <el-input-number
              v-model="formData.brokerageSecondPercent"
              :max="100"
              :min="0"
              class="!w-xs"
              placeholder="请输入二级返佣比例"
            />
            <el-text class="w-full" size="small" type="info">
              订单交易成功后给推广人的推荐人返佣的百分比
            </el-text>
          </el-form-item>
          <el-form-item label="佣金冻结天数" prop="brokerageFrozenDays">
            <el-input-number
              v-model="formData.brokerageFrozenDays"
              :min="0"
              class="!w-xs"
              placeholder="请输入佣金冻结天数"
            />
            <el-text class="w-full" size="small" type="info">
              订单分佣自核销/确认收货起算：支付后先冻结不可提；到期后进入可提现。填 0
              表示核销后立即进入可提现（并非支付后即可提）
            </el-text>
          </el-form-item>
          <el-form-item label="提现最低金额" prop="brokerageWithdrawMinPrice">
            <el-input-number
              v-model="formData.brokerageWithdrawMinPrice"
              :min="0"
              :precision="2"
              class="!w-xs"
              placeholder="请输入提现最低金额"
            />
            <el-text class="w-full" size="small" type="info">
              用户提现最低金额限制，单位：元
            </el-text>
          </el-form-item>
          <el-form-item label="提现手续费" prop="brokerageWithdrawFeePercent">
            <el-input-number
              v-model="formData.brokerageWithdrawFeePercent"
              :max="100"
              :min="0"
              class="!w-xs"
              placeholder="请输入提现手续费"
            />
            <el-text class="w-full" size="small" type="info">
              提现手续费百分比，范围 0-100，0 为无提现手续费。例：设置 10，即收取 10% 手续费，提现
              10 元，到账 9 元，1 元手续费
            </el-text>
          </el-form-item>
          <el-form-item label="提现方式" prop="brokerageWithdrawTypes">
            <el-checkbox-group v-model="formData.brokerageWithdrawTypes">
              <el-checkbox
                v-for="dict in getIntDictOptions(DICT_TYPE.BROKERAGE_WITHDRAW_TYPE)"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </el-checkbox>
            </el-checkbox-group>
            <el-text class="w-full" size="small" type="info"> 商城开通提现的付款方式</el-text>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <!-- 保存 -->
      <el-form-item>
        <el-button :loading="formLoading" type="primary" @click="submitForm"> 保存</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as ConfigApi from '@/api/mall/trade/config'
import * as AreaApi from '@/api/system/area'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { defaultProps } from '@/utils/tree'
import { cloneDeep } from 'lodash-es'

defineOptions({ name: 'TradeConfig' })

const message = useMessage() // 消息弹窗

const areaTree = ref<any[]>([])
const areaCascaderProps = {
  ...defaultProps,
  multiple: true
}

const formLoading = ref(false) // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
const formRef = ref()
const activeTab = ref('0')
const formData = ref<ConfigApi.ConfigVO>({
  id: null,
  afterSaleRefundReasons: [],
  afterSaleReturnReasons: [],
  deliveryExpressFreeEnabled: false,
  deliveryExpressFreePrice: 0,
  deliveryExpressFreeExcludeAreaIds: [],
  deliveryPickUpEnabled: false,
  deliveryPickUpMode: 0,
  pickUpVerifyAutoCloseEnabled: false,
  pickUpVerifyAutoCloseDays: 7,
  brokerageEnabled: false,
  brokerageEnabledCondition: undefined,
  brokerageBindMode: undefined,
  brokeragePosterUrls: [],
  brokerageFirstPercent: 0,
  brokerageSecondPercent: 0,
  brokerageWithdrawMinPrice: 0,
  brokerageWithdrawFeePercent: 0,
  brokerageFrozenDays: 0,
  brokerageWithdrawTypes: []
})
const formRules = reactive({
  afterSaleRefundReasons: [{ type: 'array', required: true, min: 1, message: '请至少填写一项退款理由', trigger: 'change' }],
  afterSaleReturnReasons: [{ type: 'array', required: true, min: 1, message: '请至少填写一项退货理由', trigger: 'change' }],
  deliveryExpressFreePrice: [{ required: true, message: '满额包邮不能为空', trigger: 'blur' }],
  pickUpVerifyAutoCloseDays: [
    { required: true, message: '超时天数不能为空', trigger: 'blur' },
    {
      type: 'number',
      min: 1,
      max: 365,
      message: '超时天数须在 1-365 之间',
      trigger: 'blur'
    }
  ],
  brokerageEnabledCondition: [{ required: true, message: '分佣模式不能为空', trigger: 'blur' }],
  brokerageBindMode: [{ required: true, message: '分销关系绑定模式不能为空', trigger: 'blur' }],
  brokerageFirstPercent: [{ required: true, message: '一级返佣比例不能为空', trigger: 'blur' }],
  brokerageSecondPercent: [{ required: true, message: '二级返佣比例不能为空', trigger: 'blur' }],
  brokerageWithdrawMinPrice: [
    { required: true, message: '用户提现最低金额不能为空', trigger: 'blur' }
  ],
  brokerageWithdrawFeePercent: [{ required: true, message: '提现手续费不能为空', trigger: 'blur' }],
  brokerageFrozenDays: [{ required: true, message: '佣金冻结时间不能为空', trigger: 'blur' }],
  brokerageWithdrawTypes: [
    {
      required: true,
      message: '提现方式不能为空',
      trigger: 'change'
    }
  ]
})

const submitForm = async () => {
  if (formLoading.value) return
  if (!formRef.value) return
  try {
    await formRef.value.validate()
  } catch (fields) {
    // Element Plus：校验失败会 reject fields，需提示并切到对应 Tab
    if (fields && typeof fields === 'object' && ('afterSaleRefundReasons' in fields || 'afterSaleReturnReasons' in fields)) {
      activeTab.value = '0'
      message.warning('请在「售后」页填写退款理由和退货理由')
    } else {
      message.warning('请完善表单必填项（含「分销」页的分佣模式、绑定方式、提现方式）')
    }
    console.warn('[TradeConfig] validate failed', fields)
    return
  }
  formLoading.value = true
  try {
    const data = cloneDeep(unref(formData.value)) as unknown as ConfigApi.ConfigVO
    if (data.deliveryPickUpMode == null) {
      data.deliveryPickUpMode = 0
    }
    if (data.pickUpVerifyAutoCloseEnabled == null) {
      data.pickUpVerifyAutoCloseEnabled = false
    }
    // 关闭门店自提时，同步关掉待核销超时关闭，避免配置语义矛盾
    if (!data.deliveryPickUpEnabled) {
      data.pickUpVerifyAutoCloseEnabled = false
    }
    if (data.pickUpVerifyAutoCloseDays == null || data.pickUpVerifyAutoCloseDays < 1) {
      data.pickUpVerifyAutoCloseDays = 7
    }
    // 金额放大
    data.deliveryExpressFreePrice = data.deliveryExpressFreePrice * 100
    data.brokerageWithdrawMinPrice = data.brokerageWithdrawMinPrice * 100
    await ConfigApi.saveTradeConfig(data)
    message.success('保存成功')
  } catch (e: any) {
    message.error(e?.message || '保存失败，请确认已执行自提模式 SQL，且分销配置完整')
  } finally {
    formLoading.value = false
  }
}

/** 查询交易中心配置 */
const getConfig = async () => {
  formLoading.value = true
  try {
    const data = await ConfigApi.getTradeConfig()
    if (data != null) {
      formData.value = {
        ...formData.value,
        ...data,
        deliveryExpressFreeExcludeAreaIds: data.deliveryExpressFreeExcludeAreaIds || [],
        deliveryPickUpMode: data.deliveryPickUpMode ?? 0,
        pickUpVerifyAutoCloseEnabled: data.pickUpVerifyAutoCloseEnabled ?? false,
        pickUpVerifyAutoCloseDays: data.pickUpVerifyAutoCloseDays ?? 7,
        // 接口缺字段时兜底，避免保存被分销必填拦住
        brokerageEnabledCondition: data.brokerageEnabledCondition ?? 0,
        brokerageBindMode: data.brokerageBindMode ?? 0,
        brokerageWithdrawTypes:
          data.brokerageWithdrawTypes?.length > 0 ? data.brokerageWithdrawTypes : [0],
        afterSaleRefundReasons: data.afterSaleRefundReasons?.length
          ? data.afterSaleRefundReasons
          : formData.value.afterSaleRefundReasons,
        afterSaleReturnReasons: data.afterSaleReturnReasons?.length
          ? data.afterSaleReturnReasons
          : formData.value.afterSaleReturnReasons
      }
      // 金额缩小（分 → 元）
      formData.value.deliveryExpressFreePrice = (data.deliveryExpressFreePrice ?? 0) / 100
      formData.value.brokerageWithdrawMinPrice = (data.brokerageWithdrawMinPrice ?? 0) / 100
    }
  } catch (e: any) {
    message.error(
      e?.message ||
        '加载交易配置失败。若刚加自提模式，请先执行 sql/mall/2026-09-16/01-自提-店铺一点模式.sql'
    )
  } finally {
    formLoading.value = false
  }
}

/** 初始化 **/
onMounted(async () => {
  areaTree.value = await AreaApi.getAreaTree()
  await getConfig()
})
</script>
